module.exports = __webpack_public_path__ + "img/society-ikkyu-avatar.e7d0ffda.png";